import _ from "lodash";
import moment from "moment";
import { FP } from "../Data";
import * as T from "../Types";
import { getString } from "./string";
import { arrayWrapper } from "./array";

/** Applied the mapping from an external source to the app properties */
export const map_item = (type: string, mapping: T.Mapping.Mapping[], ...objects: Record<string, unknown>[]): T.DataSource["element_mapping"][number]["items"][number]["data"] => {
    if (!Array.isArray(mapping) || mapping.length === 0) return [];
    // Isolate the mapping properties of the correct type
    const mapping_properties = mapping.filter(m => !Array.isArray(m.type) || m.type.includes(type));
    // Merge all the properties and group them by similar keys
    const all_properties = objects
        .filter(o => typeof o === "object" && o !== null)
        .map(o => Object.entries(o).map(([key, value]) => ({ key, value }))).flat();
    const grouped_properties = _.groupBy(all_properties, "key");
    // Create a new object to store the mapped properties
    const property_data = [] as ReturnType<typeof map_item>;

    for (const [ext_key, values] of Object.entries(grouped_properties)) {
        // Find the mapping for the external key
        const property = mapping_properties.find(p => p.source_name === ext_key);
        // Didn't find a match for the external key
        if (!property || !property.app_name) continue;
        // Get the string values
        const is_array_values = values.every(v => Array.isArray(v.value));
        const string_values = is_array_values
            ? values.map(v => {
                const array_values = arrayWrapper(v.value)
                    .map(v => v.toString?.())
                    .filter(t => typeof t === "string" && t.length > 0);
                if (array_values.length === 0) return null;
                else return array_values;
            }).filter(v => v !== null)
            : values.map(v => v.value?.toString?.()).filter(str => typeof str === "string" && str.length > 0);

        if (string_values.length > 0) property_data.push({
            options: string_values,
            value: string_values[0],
            app_name: property.app_name,
            data_flag: is_array_values ? "array" : "single",
        });
    }
    return property_data;
};

/** Map a raw value to a formatted app property */
export const map_value = (item: T.Mapping.AnyElementsData, property: keyof T.Mapping.AnyElementsData, sub_type: string) => {
    let value = item?.[property];
    if (typeof value === undefined || value === "" || value === null) return undefined;

    if (sub_type === FP.EQUIPEMENT_FORM) {
        const eq_property = property as keyof T.Mapping.MappingAisetData["equipments"][number];
        if (eq_property === "brand") value = item?.["brand_name"];
        else if (eq_property === "model") value = item?.["model_name"];
        else if (eq_property === "dateFabrication") value = moment(item?.["dateFabrication"]).format("DD/MM/YYYY");
    }
    else if (sub_type === FP.BUILDING_FORM) {
        const b_property = property as keyof T.Mapping.MappingAisetData["buildings"][number];
        if (b_property === "affectation") value = item?.["affectation_label"];
    }
    else if (sub_type === FP.EMPLACEMENT_FORM) {
        const emp_property = property as keyof T.Mapping.MappingAisetData["emplacements"][number];
        if (emp_property === "actif_detail") value = item?.["actif_detail_name"];
        else if (emp_property === "criticity") value = item?.["criticity_label"];
    }
    // else if (sub_type === FP.SITE_FORM) {
    //     const s_property = property as keyof T.Mapping.MappingAisetData["sites"][number];

    // }
    // Return the value transformed
    return value;
}